import { LOAN_PROCESS_STATUSES } from "./lendingOperationsConstants";

export {
  getEntityId,
  getAuthorName,
  normalizeTimelineLogs,
  getAttachmentUrl,
  parseApiErrorMessage,
} from "./mehrsanOperationsUtils";

export const getLoanStatusLabel = (status, statusTitle) => {
  if (statusTitle && String(statusTitle).trim()) return statusTitle;
  const value = Number(status);
  if (Number.isNaN(value)) return "نامشخص";
  const match = LOAN_PROCESS_STATUSES.find((s) => s.value === value);
  return match?.label || "نامشخص";
};

export const formatMoney = (value) => {
  if (value == null || value === "") return null;
  const n = Number(value);
  if (Number.isNaN(n)) return null;
  return `${n.toLocaleString("fa-IR")} ریال`;
};

export const pickField = (obj, camel, pascal) =>
  obj?.[camel] ?? obj?.[pascal] ?? null;

export const buildInitialLendingLogForm = (process) => ({
  status: Number(pickField(process, "currentStatus", "CurrentStatus") ?? 1),
  actionTitle: "",
  description: "",
  approvedAmount: pickField(process, "approvedAmount", "ApprovedAmount") ?? "",
  referenceNumber: pickField(process, "referenceNumber", "ReferenceNumber") ?? "",
  trackingCode: pickField(process, "trackingCode", "TrackingCode") ?? "",
  nextFollowUpDate: "",
  attachmentUrl: "",
});

export const emptyLendingLogFormFields = () => ({
  actionTitle: "",
  description: "",
  approvedAmount: "",
  nextFollowUpDate: "",
  attachmentUrl: "",
});

export const isLoanProcessClosed = (process, logs = []) =>
  hasLoanDisbursement(process, logs);

export const hasLoanApproval = (process, logs = []) => {
  const current = Number(pickField(process, "currentStatus", "CurrentStatus"));
  if (current === 5) return true;
  return (logs || []).some(
    (log) => Number(pickField(log, "status", "Status")) === 5
  );
};

export const hasLoanDisbursement = (process, logs = []) => {
  const current = Number(pickField(process, "currentStatus", "CurrentStatus"));
  if (current === 7 || current === 8) return true;
  return (logs || []).some((log) => {
    const s = Number(pickField(log, "status", "Status"));
    return s === 7 || s === 8;
  });
};

export const buildStatusUpdateActionTitle = (status) => {
  const label = getLoanStatusLabel(status);
  return `بروزرسانی وضعیت: ${label}`;
};
